import React from "react";

// Helper to safely render HTML content
const AnswerContent = ({ html }) => {
  // Use dangerouslySetInnerHTML to render HTML from the answer field
  return (
    <div
      className="text-body-b2" // Assuming this is a pre-defined class for text style
      style={{ color: "#C8CED3" }} // Default text color for the content
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

// Helper to format the date
const formatDate = (isoString) => {
  if (!isoString) return "";
  try {
    const date = new Date(isoString);
    return new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).format(date);
  } catch (e) {
    const parts = isoString.split(" ")[0].split("-");
    return `${parts[2]}/${parts[1]}/${parts[0]}`;
  }
};

// Component to display "Your Lesson" or "Your Revelation"
const EntryDetail = ({ title, answers }) => {
  if (!answers || answers.length === 0) return null;

  // Use the first answer's answer_text/answer
  const answerContent = answers[0].answer;

  return (
    <div className="d-flex flex-column mt-3">
      {/* Title: 'Your Lesson' or 'Your Revelation' */}
      <span
        className="fw-normal fs-6"
        style={{ color: "#8798A7", marginBottom: "8px" }}
      >
        {title}
      </span>

      {/* Answer Content */}
      <AnswerContent html={answerContent} />
    </div>
  );
};

export const LessonRevelationCard = ({ lessonRevelation = [] }) => {

  return (
    <div className="d-flex flex-column w-100" style={{ gap: "20px" }}>
      {lessonRevelation.map((entry, index) => (
        // Individual Card Container
        <div
          key={entry.user_journal_id || index}
          className="lesson-revelation-card p-4 d-flex flex-column rounded-4" // Use custom class for specific styles
        >
          {/* Header Row: Date + Journal Title + Badge */}
          <div className="d-flex align-items-center">
            {/* Date and Journal Title */}
            <span className="fw-normal fs-6 me-3" style={{ color: "#8798A7" }}>
              {formatDate(entry.completed_at)} Journal Title
            </span>

            {/* Dynamic Badge/Chip */}
            <div
              className="d-flex justify-content-center align-items-center rounded-pill px-3"
              style={{
                backgroundColor: "#008CFF", // A default blue-ish background for badges
                color: "#fff",
                fontSize: "14px",
                height: "22px",
              }}
            >
              {entry.title.includes("|")
                ? entry.title.split("|")[0].trim()
                : entry.title.trim()}
            </div>
          </div>

          {/* Lesson Details */}
          <EntryDetail title="Your Lesson" answers={entry.lesson_answers} />

          {/* Revelation Details */}
          <EntryDetail
            title="Your Revelation"
            answers={entry.revelation_answers}
          />
        </div>
      ))}
    </div>
  );
};
